import reducer, { saga as sagas, actions } from './ducks';
import * as translations from './translations';
import widgets from './widgets';

export const name = 'offerItem';
export const realName = 'offerItem';
export { reducer, widgets, sagas, actions, translations };
export * from './routes';
